import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { NotificationViewModel, RequestNotificationAccessModel } from '../../..'
import NotificationAutoInterUpdator from '../../../NotificationAutoInterUpdator'
import i18next from 'i18next'

const NewDevelopmentRequestNotif = (props) => {
  const { notification } = props
  const [request, setRequest] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  NotificationAutoInterUpdator(props)
  useEffect(() => {
    const fetchRequest = async () => {
      setIsLoading(true)
      try {
        const res = await axios.get(
          `/requests/${notification?.accompaniedData?.requestId}`
        )
        setRequest(res.data.request)
      } catch (error) {
        console.log(error)
      }
      setIsLoading(false)
    }
    if (notification?.accompaniedData?.requestId) fetchRequest()
  }, [notification?.accompaniedData?.requestId])
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationViewModel
      {...props}
      learningSectionContent={
        rtl
          ? 'بعد قبول هذا العرض ، يمكنك إرسال قناة استثمار إلى المستثمر المحتمل أو إنشاء قناة جديدة في قنوات مشروعك ، للتعامل مع المزيد من التفاعلات'
          : 'After accepting this offer you may send the potential investor an investment channel or create a new one in your project channels, to handle more interactions'
      }
      notificationBody={
        <RequestNotificationAccessModel
          requestType='development'
          requestData={request}
          isLoading={isLoading}
          {...props}
          notificationBodyContent={
            rtl ? 'لديك عرض تطوير جديد' : 'You have new development offer'
          }
        />
      }
      buttonsArray={[]}
    />
  )
}

export default NewDevelopmentRequestNotif
